import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-fixed tw-left-0 tw-top-0 tw-z-40 tw-h-full tw-w-full tw-bg-white tw-opacity-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerLoader2 = _resolveComponent("TablerLoader2")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass({
        'tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center':
          _ctx.coverContainer
      }),
      "data-testid": "studio-spinner"
    }, [
      _createVNode(_component_TablerLoader2, {
        class: _normalizeClass({
          'tw-animate-spin tw-text-deep-orange-500': true,
          'tw-h-4 tw-w-4': _ctx.size === 'xxsmall',
          'tw-h-6 tw-w-6': _ctx.size === 'xsmall',
          'tw-h-8 tw-w-8': _ctx.size === 'small',
          'tw-h-12 tw-w-12': _ctx.size === 'medium',
          'tw-h-16 tw-w-16': _ctx.size === 'large'
        })
      }, null, 8, ["class"])
    ], 2),
    (_ctx.overlay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}